import { render } from "./wfm-global-search.vue?vue&type=template&id=a736fac6&scoped=true"
import script from "./wfm-global-search.vue?vue&type=script&lang=js"
export * from "./wfm-global-search.vue?vue&type=script&lang=js"

import "./wfm-global-search.vue?vue&type=style&index=0&id=a736fac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a736fac6"]])

export default __exports__